export class RequestUrlUndefinedParamError extends Error {
  constructor(
    public message: string,
    public url: string
  ) {
    super(message);
  }
}
